import React, { createContext, useState, useEffect, useContext } from "react";
import { fetchAllTables } from "../../services/pos/Tables";

const TablesContext = createContext({
  tables: [],
  loading: true,
  error: null,
  refresh: () => {},
});

export const TablesProvider = ({ children }) => {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadTables = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchAllTables();
      setTables(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err?.message || "فشل في جلب الطاولات");
      setTables([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTables();
  }, []);

  return (
    <TablesContext.Provider value={{ tables, loading, error, refresh: loadTables }}>
      {children}
    </TablesContext.Provider>
  );
};

export const useTables = () => useContext(TablesContext);
